import { render } from "./SidePanelHeader.vue?vue&type=template&id=74b61275"
import script from "./SidePanelHeader.vue?vue&type=script&lang=js"
export * from "./SidePanelHeader.vue?vue&type=script&lang=js"

import "./SidePanelHeader.vue?vue&type=style&index=0&id=74b61275&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__